// import Swiper JS
import Swiper from 'swiper';

// import Swiper styles
import 'swiper/css/bundle';

// import notification library
import AWN from "awesome-notifications";

//import cookie library
import Cookies from 'js-cookie';

document.addEventListener("DOMContentLoaded", function(e) {

	let purchase_form = document.getElementsByClassName('ff_purchase_process');

	//if the form exists on this page
	if(purchase_form.length > 0) {

		//replace the original element for easy referencing
		purchase_form = purchase_form[0];

		//#region Currency Formatter
		let currency = Intl.NumberFormat("en-US", {
			style: "currency",
			currency: "GBP",
		});
		//#endregion

		//#region HPI API
		//adds an event listener on the reg and mileage input
		//adds an event listener on the reg and mileage input
		document.addEventListener('click', function (e) {
			if (!e.target.matches('#get_valuation_quote')) return;
			get_valuation_quote(e);
		}, false);

		document.addEventListener('click', function (e) {
			if (!e.target.matches('.get_valuation_quote')) return;

			let halting = !e.target.matches('.valuation_non_halting');

			if(halting) {
				e.preventDefault();
			}

			get_valuation_quote(e, true);
		}, false);

		function get_valuation_quote(e, one_time = false) {

			//fetch the current valuation tally
			let valuation_tally = Cookies.get('jd-hpi-valuations');

			//if the user has made a previous request and they've made more than 2
			if(valuation_tally && valuation_tally > 1) {
				new AWN().alert("Sorry, you've exceeded your daily vehicle valuation limit. Please try again tomorrow.");
				return;
			}

			//defines an object of input values for reg and mileage
			let part_ex = {
				'reg': document.getElementById('ff_' + purchase_form.dataset.form_id + '_reg').value,
				'mileage': document.getElementById('ff_' + purchase_form.dataset.form_id + '_mileage').value,
			};

			//get all active errors
			let errors = document.getElementsByClassName('hpi-error');
			while (errors.length > 0) errors[0].remove();

			if(part_ex.reg && part_ex.mileage) {

				//prevent default if not already done
				e.preventDefault();

				let parent_slide = false;

				if(!one_time) {
					parent_slide = document.getElementById('get_valuation_quote').parentNode.parentNode.parentNode;
				} else {
					parent_slide = document.getElementsByClassName('get_valuation_quote')[0].parentNode.parentNode;
				}

				parent_slide.classList.add('api-request');

				setTimeout(function() {
					parent_slide.classList.remove('api-request');
				}, 15000);
				
				//make a POST request to the valuation endpoint, providing the cars reg and mileage if available
				fetch(ajax_object.homeurl + "/wp-json/john-darke/hpi/get-valuation", { 
					method: "POST",
					headers: {
						"Accept": "application/json, text/plain, */*",
						"Content-Type": "application/json"
					},
					body: JSON.stringify({
						reg: part_ex.reg,
						mileage: (part_ex.mileage != '') ? part_ex.mileage : '300'
					})
				}).then(function(response) {

					//create a new date and set it to midnight tomorrow
					let midnight_tonight = new Date();
						midnight_tonight.setHours(23,59,59,59);

					//update the tally with one new request
					Cookies.set('jd-hpi-valuations', (valuation_tally ? parseInt(valuation_tally) + 1 : 1), {
						expires: midnight_tonight
					});

					return response.text();
				}).then(function(data) {

					//save the valuation data to the variable for later
					let hpi_data = JSON.parse(data);

					//defines the names of our hidden fields in an object with their new values
					let hpi_fields = {
						'part_ex_make': hpi_data.make ? hpi_data.make : 'N/A',
						'part_ex_model': hpi_data.model ? hpi_data.model : 'N/A',
						'part_ex_average_value': hpi_data.valuation != 'N/A' ? currency.format(hpi_data.valuation) : 'N/A',
						'part_ex_valuation_date': hpi_data.valuation_date,
					}

					//loop over each field
					for (const input_name in hpi_fields) {

						//attempt to fetch the field from the DOM
						let field = document.querySelector('input[name="' + input_name + '"]');

						//if we have the field
						if(field) {

							//update its value
							field.value = hpi_fields[input_name];
						}
					}

					let hpi_container = document.getElementsByClassName('hpi-result-container')[0];

					if(hpi_container && !one_time) {
						hpi_container.classList.add('active');
					}

					//get the display value
					let display_value = document.getElementById('trade_in_value');

					//if we have a display value
					if(display_value) {

						//update it with the current valuation
						display_value.innerHTML = hpi_data.valuation != 'N/A' ? '£' + (hpi_data.valuation).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : 'N/A';
					}

					let existing_reg = document.getElementsByClassName('nice-registration-number')[0];

					if(existing_reg) {
						existing_reg.parentNode.removeChild(existing_reg);
					}

					var moment = require('moment');
					let date = moment(hpi_data.intro_date);

					let display_reg = '<div class="nice-registration-number"><h6>Valuation result for</h6><span>' + hpi_data.reg + '</span><p>' + (hpi_data.make + ' ' + hpi_data.model) + ' <br> ' + date.format('MM-YYYY') + '</p></div>';

					if(display_reg) {
						hpi_container.classList.add('reg-number');
						hpi_container.insertAdjacentHTML("afterbegin", display_reg);
					}

					parent_slide.classList.remove('api-request');

					if(one_time) {
						let button = document.getElementsByClassName('get_valuation_quote')[0];

						if(button) {
							button.classList.remove('get_valuation_quote');
							button.click();
						}
					}
				});
			} else {
				let fields = {
					['ff_' + purchase_form.dataset.form_id + '_reg']: part_ex.reg,
					['ff_' + purchase_form.dataset.form_id + '_mileage']: part_ex.mileage,
				};

				Object.keys(fields).forEach(function (item) {

					//if there's no value for this field
					if(!fields[item]) {

						let element = document.getElementById(item);
						let error = document.createElement('div');
							error.innerHTML = 'This field is required';
							error.classList.add('error');
							error.classList.add('hpi-error');
							error.classList.add('text-danger');
							error.style.marginTop = '4px';
							error.style.fontSize = '12px';
	
						element.parentNode.insertAdjacentHTML('afterEnd', error.outerHTML);
					}
				});
			}
		}
		//#endregion

		//#region Online or Dealer Finance
		document.addEventListener('click', function (event) {
			if (event.target.matches('#choose_finance_online') || event.target.matches('#choose_finance_dealer')) {	
				
				let options = document.querySelectorAll('input[data-name="finance_method"]');
				let buttons = document.getElementById('finance-option-buttons');
				let button_class = 'online';

				if(options) {
					for(let i = 0; i < options.length; i++) {
						if(options[i].checked) {
							options[i].click();
						}
					}
				}

				switch(event.target.id) {
					case 'choose_finance_online':
						options = document.querySelector('input[data-name="finance_method"][value="Apply Online"]');
						toggle_santander_modal();
						break;
					case 'choose_finance_dealer':
						options = document.querySelector('input[data-name="finance_method"][value="With Dealer"]');
						button_class = 'dealer';
						break;
				}

				if(options) {
					options.click();

					if(buttons) {
						buttons.classList.remove('online');
						buttons.classList.remove('dealer');
						buttons.classList.add(button_class);
					}
				}
			}
		}, false);

		document.addEventListener('click', function (event) {
			if (!event.target.matches('#open_santander_finance')) return;

			event.preventDefault();

			const h = 700;
			const w = 1150;

			const y = window.top.outerHeight / 2 + window.top.screenY - ( h / 2);
			const x = window.top.outerWidth / 2 + window.top.screenX - ( w / 2);
			window.open(event.target.href, 'Apply for Finance Online', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`);
		});

		document.addEventListener('click', function (event) {
			if (!event.target.matches('#close_santander_finance')) return;

			event.preventDefault();
			toggle_santander_modal(false);
		});

		function toggle_santander_modal(open = true) {
			let popup = document.getElementById('santander-popup');

			if(popup) {
				if(open) {
					popup.classList.add('active');
				} else {
					popup.classList.remove('active');
				}
			}
		}
		//#endregion

		//#region Santander Finance API
		try {
			//adds an event listener on the reg and mileage input
			document.getElementById('get_finance_quote').addEventListener("click", function() {

				let parent_slide = document.getElementById('get_finance_quote').parentNode.parentNode.parentNode;

				parent_slide.classList.add('api-request');

				setTimeout(function() {
					parent_slide.classList.remove('api-request');
				}, 15000);

				//defines an object of input values for deposit, term and mileage
				let finance_options = {
					'reg': document.querySelector('input[type="hidden"][name="vehicle_reg"]').value,
					'price': document.querySelector('input[type="hidden"][name="vehicle_price"]').value,
					'term': document.getElementById('ff_' + purchase_form.dataset.form_id + '_finance_term').value,
					'mileage': document.getElementById('ff_' + purchase_form.dataset.form_id + '_finance_mileage').value,
					'deposit': document.getElementById('ff_' + purchase_form.dataset.form_id + '_finance_deposit').value,
					'partex': document.querySelector('input[name="part_ex_average_value"]').value,
				};
				
				//make a POST request to the valuation endpoint, providing the cars reg and mileage if available
				fetch(ajax_object.homeurl + "/wp-json/john-darke/finance/get", { 
					method: "POST",
					body: "reg=" + finance_options.reg + "&price=" + finance_options.price + "&term=" + finance_options.term + "&mileage=" + finance_options.mileage + "&deposit=" + finance_options.deposit + "&partex=" + finance_options.partex,
					headers: {
						"Accept": "application/json, text/plain, */*",
						"Content-Type": "application/x-www-form-urlencoded"
					}
				}).then(function(response) {
					return response.text();
				}).then(function(data) {

					//save the finance data to the variable for later
					let finance_data = JSON.parse(data);

					//defines the names of our hidden fields in an object with their new values
					let finance_fields = {};

					let finance_type = document.querySelector('input[name="finance_type"]:checked').value;

					//if we have a PCP quote
					if(finance_data.pcp.data.quote && finance_type === 'pcp') {

						//use PCP
						finance_fields = {
							'finance_car_value': currency.format(finance_data.pcp.data.quote.costprice),
							'finance_loan_amount': currency.format((finance_data.pcp.data.quote.costprice - finance_options.deposit)),
							'finance_apr': finance_data.pcp.data.quote.apr + '%',
							'finance_monthly_payments': currency.format(finance_data.pcp.data.quote.regular_monthly_payment),
							'finance_total_amount': currency.format(finance_data.pcp.data.quote.totalamount),
						}
					} else if(finance_data.cs.data.quote && finance_type === 'hp') { //otherwise

						//use CS instead
						finance_fields = {
							'finance_car_value': currency.format(finance_data.cs.data.quote.costprice),
							'finance_loan_amount': currency.format((finance_data.cs.data.quote.costprice - finance_options.deposit)),
							'finance_apr': finance_data.cs.data.quote.apr + '%',
							'finance_monthly_payments': currency.format(finance_data.cs.data.quote.regular_monthly_payment),
							'finance_total_amount': currency.format(finance_data.cs.data.quote.totalamount),
						}
					} else {
						new AWN().alert('Your chosen finance type is not available for this vehicle. Please try another finance type or speak to a member of the team for more information.');
						parent_slide.classList.remove('api-request');
						return;
					}

					//loop over each field
					for (const input_name in finance_fields) {

						//attempt to fetch the field from the DOM
						let field = document.querySelector('input[name="' + input_name + '"]');

						//if we have the field
						if(field) {

							//update its value
							field.value = finance_fields[input_name];
						}
					}

					let finance_container = document.getElementsByClassName('finance-result-container')[0];

					if(finance_container) {
						finance_container.classList.add('active');
					}

					parent_slide.classList.remove('api-request');
				});
			});
		} catch(e) {

		}
		//#endregion

		//#region Duplicate Fields/Confirmation
		//defines an array of duplicate fields, with 0 being the original field and 1 being the duplicate
		let duplicate_fields = [
			[
				document.getElementById('ff_' + purchase_form.dataset.form_id + '_names_first_name_'),
				document.getElementById('ff_' + purchase_form.dataset.form_id + '_names_confirmation_first_name_')
			],
			[
				document.getElementById('ff_' + purchase_form.dataset.form_id + '_names_last_name_'),
				document.getElementById('ff_' + purchase_form.dataset.form_id + '_names_confirmation_last_name_')
			],
			[
				document.getElementById('ff_' + purchase_form.dataset.form_id + '_email'),
				document.getElementById('ff_' + purchase_form.dataset.form_id + '_email_confirmation')
			],
			[
				document.getElementById('ff_' + purchase_form.dataset.form_id + '_phone'),
				document.getElementById('ff_' + purchase_form.dataset.form_id + '_phone_confirmation')
			],
		];

		//loop over each duplicate field
		for(let i = 0; i < duplicate_fields.length; i++) {

			//if both the original and duplicate exists
			if(duplicate_fields[i][0] && duplicate_fields[i][1]) {

				//add an event listener to the original field
				duplicate_fields[i][0].addEventListener('input', function(e) {
					
					//set the value of the duplicate field to the value of the original field
					duplicate_fields[i][1].value = e.target.value;
				});
			}
		}
		//#endregion
	
		//#region Slides
		const swiper = new Swiper(".purchase-process-slides", {
			allowTouchMove: false,
			autoHeight: true,
		});

		var slide_observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutationRecord) {
				let form = document.getElementsByClassName('frm-fluent-form')[0];
				let form_steps = document.getElementsByClassName('ff-step-body')[0];

				switch(form_steps.getAttribute('style')) {
					case "width: 600%;":
						swiper.slideTo(0);
						break;
					case "width: 600%; left: -100%;":
						swiper.slideTo(1);
						break;
					case "width: 600%; left: -200%;":
						swiper.slideTo(2);
						break;
					case "width: 600%; left: -300%;":
						swiper.slideTo(3);
						break;
					case "width: 600%; left: -400%;":
						swiper.slideTo(4);
						break;
					case "width: 600%; left: -500%;":
						swiper.slideTo(5);
						break;
					case "width: 600%; left: 0%;":

						//if the form has been completed, we can show the final slide
						if(form.classList.contains('ff_force_hide')) {
							swiper.slideTo(6);
						} else {
							swiper.slideTo(0);
						}
						break;
				}
			});    
		});

		try {
			slide_observer.observe(document.getElementsByClassName('ff-step-body')[0], { attributes : true, attributeFilter : ['style'] });
		} catch(e) {
		}
		//#endregion
	
		//#region Back to Vehicle Button
		let form_steps = purchase_form.getElementsByClassName('fluentform-step');

		//if the form has more than one step
		if(form_steps && form_steps.length > 0) {
			let next_step = form_steps[0].getElementsByClassName('ff-btn-next')[0];

			if(next_step) {
				let vehicle_url = document.querySelector('input[name="vehicle_url"]').value;

				if(vehicle_url) {
					setTimeout(function() {
						next_step.insertAdjacentHTML('beforebegin', '<a href="' + vehicle_url + '" class="ff-btn ff-btn-prev ff-btn-secondary">Back to vehicle</a>');
					}, 300);
				}
			}
		}
		//#endregion
	
		//#region Order Panel
		document.addEventListener('input', function (event) {

			if (!event.target.matches('[name="finance_settlement_figure"]')) return;

			//select value
			let value = event.target.value;

			//get the display value
			let display_value = document.getElementById('trade_in_value');

			//if we have a display value and a valid select value
			if(value && display_value) {

				//update it with the current valuation
				display_value.innerHTML = ((display_value.innerHTML).includes(" (") ? (display_value.innerHTML).substring((display_value.innerHTML), (display_value.innerHTML).indexOf(' (')) : display_value.innerHTML) + ' (Settlement: £' + value + ')';
			}
		}, false);

		document.addEventListener('input', function (event) {

			if (!event.target.matches('[name="payment_method"]')) return;

			//select value
			let value = event.target.value;

			//get the display value
			let display_value = document.getElementById('purchase_option_value');

			//if we have a display value and a valid select value
			if(value && display_value) {

				//update it with the current valuation
				display_value.innerHTML = value;
			}
		}, false);

		document.addEventListener('click', function (event) {

			if (!event.target.matches('[name="extras[]"]')) return;

			let extra = event.target;
			let text = extra.nextElementSibling.children[0].innerHTML;

			//get the display value
			let display_value = document.getElementById('extras_value');

			//if we have a display value and a valid select value
			if(text && display_value) {

				let extra_nicename = text.split('<small>')[0];

				//if the extra is already checked
				if(!extra.checked) {

					//remove the current extra from the display value
					display_value.innerHTML = ((display_value.innerHTML.replace(extra_nicename + ', ', "")).replace(', ' + extra_nicename, "")).replace(extra_nicename, "");

					//if after this the value is empty
					if(display_value.innerHTML == "") {

						//add the N/A placeholder
						display_value.innerHTML = 'N/A';
					}
				} else {

					//if the display value is currently N/A
					if(display_value.innerHTML == "N/A") {

						//change it to an empty string
						display_value.innerHTML = '';
					}

					//update it with the current extra
					display_value.innerHTML = display_value.innerHTML + ((display_value.innerHTML != "") ? ', ' : '') + extra_nicename.split('<small>')[0];
				}
			}
		}, false);

		var observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutationRecord) {
				let form = document.getElementsByClassName('ff-step-body')[0];
				let your_order = document.getElementById('your-order');

				if(your_order) {
					//if this is on the last slide
					if(form.getAttribute('style') == 'width: 600%; left: -500%;') {
						your_order.classList.remove('inactive');
					} else {
						your_order.classList.add('inactive');
					}
				}
			});    
		});
			
		try {
			observer.observe(document.getElementsByClassName('ff-step-body')[0], { attributes : true, attributeFilter : ['style'] });
		} catch(e) {
		}

		document.addEventListener('click', function (event) {

			if (!event.target.matches('.pp-slide-target')) return;

			let target_slide = event.target.getAttribute('data-target');

			if(target_slide) {
				let slides = document.getElementsByClassName('fluentform-step');

				if(slides) {
					for(let i = 0; i < slides.length; i++) {

						if(i == target_slide) {

							let buttons = document.getElementsByClassName('ff-btn-prev');

							if(buttons.length) {
								let step_body = document.getElementsByClassName('ff-step-body')[0];

								for(let ii = (buttons.length - 1); ii > i; ii--) {
									buttons[ii].click();
								}
							}
						}
					}
				}
			}

		}, false);
		//#endregion
	
		//#region Print Confirmation
		document.addEventListener('click', function (event) {
			if (!event.target.matches('#print_confirmation')) return;		
			
			window.print();
		}, false);
		//#endregion
	}
});
